import React from "react";
import { MessageNotification } from "../../../cores/notifications/interfaces/api/get-notifications";
import { SocialProviderNameMapper } from "../../../cores/socialPost/config";
import { SocialProviderIcon } from "../socialPost/selector/SocialProviderIcon";

interface Props {
  notification: MessageNotification; 
}

export default function MessageNotificationItem({ notification }: Props) {
  return (
    <div className="d-flex align-items-center border-bottom">
      <SocialProviderIcon
        className="mr-3"
        isSelected
        showErrors={false}
        socialProvider={{
          id: notification.type,
        }}
      />
      <div className="d-flex flex-column overflow-hidden">
        <span>Nuevo Mensaje de {`${SocialProviderNameMapper[notification.type]}`}</span>
        <span className="text-truncate text-muted">
          {notification.from.name}: {notification.message}
        </span>
      </div>
    </div>         
  );
}
